import {RouteNames} from '@/brief-hub/router/route-names';
import {StrategyDraftState} from '@/common/api/api-raw-types';
import StrategyBriefFreelancerProfile from '@/brief-hub/strategy/deposit/freelancer/StrategyBriefFreelancerProfile.vue';
import StrategyBriefFreelancerSkills from '@/brief-hub/strategy/deposit/freelancer/StrategyBriefFreelancerSkills.vue';
import StrategyBriefConditionsWhere from '@/brief-hub/strategy/deposit/conditions/StrategyBriefConditionsWhere.vue';
import StrategyBriefMissionDescription from '@/brief-hub/strategy/deposit/mission/StrategyBriefMissionDescription.vue';
import StrategyBriefOverview from '@/brief-hub/strategy/deposit/overview/StrategyBriefOverview.vue';
import StrategyBriefFreelancerFunctionalScopes from '@/brief-hub/strategy/deposit/freelancer/StrategyBriefFreelancerFunctionalScopes.vue';
import StrategyBriefFreelancerIndustryExpertises from '@/brief-hub/strategy/deposit/freelancer/StrategyBriefFreelancerIndustryExpertises.vue';
import StrategyBriefRedirectionRegular from '@/brief-hub/strategy/deposit/freelancer/StrategyBriefRedirectionRegular.vue';
import {useNavigationStrategyService} from '../brief/NavigationStrategyService';
import NotFound from '@/brief-hub/common/ui/components/NotFound.vue';
import StrategyBriefConditionsWhenV2 from '@/brief-hub/strategy/deposit/conditions/StrategyBriefConditionsWhenV2.vue';

const {requireDraftState, requireRedirectionReason} = useNavigationStrategyService();
const STRATEGY_BASE_URL = '/strategy';
export const routesStrategy = [
    {
        path: `${STRATEGY_BASE_URL}/new:wildcard(.*)`,
        redirect: {name: RouteNames.STRATEGY_BRIEF_NEW},
    },
    {
        path: `${STRATEGY_BASE_URL}/draft/new/freelancer-profile`,
        name: RouteNames.STRATEGY_BRIEF_NEW,
        component: StrategyBriefFreelancerProfile,
    },
    {
        path: `${STRATEGY_BASE_URL}/draft/new:wildcard(.*)`,
        redirect: {name: RouteNames.STRATEGY_BRIEF_NEW},
    },
    {
        path: `${STRATEGY_BASE_URL}/draft/:id/freelancer-profile`,
        name: RouteNames.STRATEGY_BRIEF_FREELANCER_PROFILE,
        component: StrategyBriefFreelancerProfile,
        beforeEnter: requireDraftState(StrategyDraftState.INITIALIZED),
    },
    {
        path: `${STRATEGY_BASE_URL}/draft/redirection`,
        name: RouteNames.STRATEGY_BRIEF_REDIRECTION_REGULAR,
        component: StrategyBriefRedirectionRegular,
        beforeEnter: requireRedirectionReason(),
    },
    {
        path: `${STRATEGY_BASE_URL}/draft/:id/freelancer-functional-scopes`,
        name: RouteNames.STRATEGY_BRIEF_FREELANCER_FUNCTIONAL_SCOPES,
        component: StrategyBriefFreelancerFunctionalScopes,
        beforeEnter: requireDraftState(StrategyDraftState.FREELANCER_SECTION_COMPLETED),
    },
    {
        path: `${STRATEGY_BASE_URL}/draft/:id/freelancer-industry-expertises`,
        name: RouteNames.STRATEGY_BRIEF_FREELANCER_INDUSTRY_EXPERTISES,
        component: StrategyBriefFreelancerIndustryExpertises,
        beforeEnter: requireDraftState(StrategyDraftState.FREELANCER_FUNCTIONAL_SCOPES_SECTION_COMPLETED),
    },
    {
        path: `${STRATEGY_BASE_URL}/draft/:id/freelancer-skills`,
        name: RouteNames.STRATEGY_BRIEF_FREELANCER_SKILLS,
        component: StrategyBriefFreelancerSkills,
        beforeEnter: requireDraftState(StrategyDraftState.FREELANCER_INDUSTRY_EXPERTISES_SECTION_COMPLETED),
    },
    {
        path: `${STRATEGY_BASE_URL}/draft/:id/conditions/when`,
        name: RouteNames.STRATEGY_BRIEF_WHEN_CONDITIONS,
        component: StrategyBriefConditionsWhenV2,
        beforeEnter: requireDraftState(StrategyDraftState.FREELANCER_SKILLS_SECTION_COMPLETED),
    },
    {
        path: `${STRATEGY_BASE_URL}/draft/:id/conditions/where`,
        name: RouteNames.STRATEGY_BRIEF_WHERE_CONDITIONS,
        component: StrategyBriefConditionsWhere,
        beforeEnter: requireDraftState(StrategyDraftState.WHEN_CONDITIONS_SECTION_COMPLETED),
    },
    {
        path: `${STRATEGY_BASE_URL}/draft/:id/mission/description`,
        name: RouteNames.STRATEGY_BRIEF_MISSION_DESCRIPTION,
        component: StrategyBriefMissionDescription,
        beforeEnter: requireDraftState(StrategyDraftState.WHERE_CONDITIONS_SECTION_COMPLETED),
    },
    {
        path: `${STRATEGY_BASE_URL}/draft/:id/overview`,
        name: RouteNames.STRATEGY_BRIEF_OVERVIEW,
        component: StrategyBriefOverview,
        beforeEnter: requireDraftState(StrategyDraftState.MISSION_DESCRIPTION_SECTION_COMPLETED),
    },
    {
        path: `${STRATEGY_BASE_URL}/draft/:id/:wildcard(.*)`,
        redirect: {name: RouteNames.STRATEGY_BRIEF_OVERVIEW},
    },
];
